import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('BROWSE', {
  FETCH_BROWSE_REQUEST: null,
  FETCH_BROWSE_SUCCESS: null,
  FETCH_BROWSE_FAILURE: null
});
